export default function EventCard({ event, x, y, isRangeEnd, showLabel, onClick, onHoverCard, dimmed, highlighted }) {
  const handleClick = (e) => {
    e.stopPropagation();
    if (onClick && !isRangeEnd) {
      onClick(event);
    }
  };

  const nodeSize = isRangeEnd ? 8 : 14;
  const isPunctual = event.type === "punctual";
  const hasDetails = event.description || event.image;

  return (
    <div
      className={[
        "tree-node",
        isRangeEnd ? "tree-node-end" : "",
        isPunctual ? "tree-node-punctual" : "",
        dimmed ? "tree-node-dimmed" : "",
        highlighted ? "tree-node-highlighted" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      style={{
        left: x,
        top: y,
        transform: "translate(-50%, -50%)",
        width: nodeSize,
        height: nodeSize,
        backgroundColor: event.color,
        cursor: isRangeEnd ? "default" : "pointer",
      }}
      onClick={handleClick}
      onMouseEnter={(e) => {
        if (!isRangeEnd && onHoverCard) onHoverCard(event, e.clientX, e.clientY);
      }}
      onMouseMove={(e) => {
        if (!isRangeEnd && onHoverCard) onHoverCard(event, e.clientX, e.clientY);
      }}
      onMouseLeave={() => {
        if (onHoverCard) onHoverCard(null);
      }}
    >
      {showLabel && event.title && (
        <span
          className={`tree-node-label${hasDetails ? " tree-node-label-has-details" : ""}`}
          style={{ fontSize: event.textSize || "14px" }}
        >
          {event.title}
        </span>
      )}
    </div>
  );
}
